import React, { useState, createContext, useEffect } from 'react';
import { API } from 'aws-amplify';
import { useAuth } from './Auth';
import { useApiError } from './ApiErrorProvider';
import { AcStatsApiInterface } from '../models/AcStatsInterface';
import { generatePrevNMonths } from '../helpers/dateHelpers';
import { error } from '../constants/bindings';

const AcStatsContext = createContext({ loading: true, AcStatsData: {} as AcStatsApiInterface });

export const AcStatsProvider = (props) => {
  const {user} = useAuth();
  const {setErrorCode} = useApiError();
  const [AcStatsData, setAcStatsData] = useState( {} as AcStatsApiInterface);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    if (!user) {
      return;
    }
    getAcStats();
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);


  const getAcStats = async () => {
    if (!user) {
      return;
    }
    setLoading(true);
    try {
      const previousMonth = generatePrevNMonths(13, 1)[0].monthNumber.toString();
      const yearForPreviousMonth = generatePrevNMonths(13, 1)[0].year.toString();

      const requestObject = {
        body: {
            year: yearForPreviousMonth,
            month: previousMonth.length === 1? '0'+ previousMonth : previousMonth,
        }
      };
      const AcStatsData = await API.post('crewlife', '/flightstats', requestObject);
      setAcStatsData(AcStatsData);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      if(e.response?.status) { setErrorCode(e.response?.status); }
      else { setErrorCode(error.DEFAULT); }
    }
  }
  
  return (
    <AcStatsContext.Provider value={{ loading, AcStatsData }} >
      {props.children}
    </AcStatsContext.Provider>
  );
}

export const useAcStats = () => {
  const context = React.useContext(AcStatsContext);
  return context;
}